export const cardSizes = {
  cr80: { width: 1012, height: 638 }, // 3.375 x 2.125 inches at 300 DPI
  '4x6': { width: 1800, height: 1200 }, // 4x6 inches at 300 DPI
};

export function getStageDimensions(cardSettings) {
  const base = cardSizes[cardSettings.size] || cardSizes.cr80;

  if (cardSettings.format === 'landscape') {
    return {
      cardWidth: base.width,
      cardHeight: base.height
    };
  }

  return {
    cardWidth: base.height,
    cardHeight: base.width
  };
}
